import React, { useEffect, useState } from 'react';
import cookie from 'react-cookies';
import Header from './Common/Header';
import Footer from './Common/Footer';
import {
    Card,
    Container,
    Button,
    OverlayTrigger,
    Tooltip,
    Nav,
    Form,
    Row,
    Col,
    Navbar,
    Carousel,
    Spinner,
} from 'react-bootstrap';
import { get, login, logout, post } from '../utills/API';
import { useHistory } from 'react-router';

import { withRouter, useParams } from 'react-router-dom';
import { decrypt } from '../utills/function';
import Signup from './MSignup';
import { required, validateMobile } from "../utills/Validation";
import GainOn_Swiggy from "../assets/images/gainon/gainon_swiggy.png"
import { Toast } from "react-bootstrap";
import ReactTelephoneInput from "react-telephone-input";
import OtpInput from "react-otp-input";
import { loginCookie } from "../utills/function";
import Wallet from './User/Wallet';
import PhoneInput from 'react-phone-input-2'
import landing_background from "../assets/images/gainon/gainon_swiggy_background.png"
import logo_header from "../assets/images/gainon/swiggy-gainon_logo.png"
import "./Swiggy_style.css"

const Swiggy_Integration = (props) => {
    const history = useHistory();
    const params = useParams();
    // After successful login to display user details 
    const [userDetails, setUserDetails] = useState({})
    const [swiggy_message, set_swiggy_message] = useState({
        message: '',
        type: ''
    })

    // To show toast message and resend otp
    const [showSuccessToast, setShowSuccessToast] = useState(false)
    const [showErrorToast, setShowErrorToast] = useState(false)
    const [isResendOTPClicked, setIsResendOTPClicked] = useState(false)
    const [toastForResendOTP, setToastForResendOTP] = useState(false)

    // Below states is used to take all the input from user
    const [swiggyCode, setSwiggyCode] = useState("")
    const [enterMobileNo, setEnterMobileNo] = useState('')
    const [OTP, setOTP] = useState('')
    const [countryCode, setCountryCode] = useState('')

    // Below states is used to manage the fields conditionally
    const [validateSwiggyField, setValidateSwiggyField] = useState(false)
    const [activateMobileField, setActivateMobileField] = useState(false)
    const [activateOTPScreen, setActivateOTPScreen] = useState(false)
    const [activateSignUpScreen, setActivateSignUpScreen] = useState(false)
    const [activeAlredyRedeemedScreen, setactiveAlredyRedeemedScreen] = useState(false)

    // Below states is used for error-messages handling for all fields/screen 
    const [mobileError, setMobileError] = useState({})
    const [swiggyCodeError, setSwiggyCodeError] = useState('')
    const [OTPError, setOTPError] = useState('')

    // Below States is used to activate loaders on buttons
    const [isSwiggyCodeVerified, setIsSwiggyCodeVerified] = useState(false)
    const [isOTPSend, setIsOTPSend] = useState(false)
    const [isOTPVerified, setIsOTPVerify] = useState(false)
    const [isSignUpSuccess, setIsSignUpSuccess] = useState(false)

    // States for new user sign-up
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')

    // Error States for sign-up
    // const [firstNameError, setFirstNameError] = useState('')
    // const [lastNameError, setLastNameError] = useState('')
    // const [emailError, setEmailError] = useState('')
    const [signUp_Error, setSignUp_Error] = useState({})


    // useEffect(() => {
    //     const fetchUserDetails = async () => {
    //         try {
    //             // console.log("Provided data: ", daa)
    //             const { data } = await get("users/detail");
    //             var userInfo = decrypt(data.data.user);
    //             setUserDetails(userInfo)
    //             console.log("userInfo: ", userInfo)
    //             localStorage.setItem('walletBalance', userInfo.wallet);
    //             localStorage.setItem('rewardBalance', userInfo.ngp_gift_discount);

    //             console.log(userInfo)
    //         } catch (e) {
    //             console.log("error", e);
    //         }
    //     }
    //     fetchUserDetails();
    // }, [])

    useEffect(() => {
        if (params && params.spc) {
            let swiggy_code = params.spc
            setSwiggyCode(swiggy_code)
        }
    }, [])


    const handleInputChange = (telNumber, selectedCountry) => {
        setShowSuccessToast(false)
        setCountryCode(selectedCountry.dialCode)
        let mobilecNumber = telNumber.replace(selectedCountry.dialCode, "");
        let mobile = mobilecNumber ? mobilecNumber.replace(/[^0-9]/g, "") : null;
        setEnterMobileNo(mobile)
    };

    const handleMobileNumberValidation = async () => {
        if (enterMobileNo !== "") {
            if (enterMobileNo.length < 10) {
                return {
                    status: true,
                    message: "*Mobile number should be 10 digits."
                };
            } else if (enterMobileNo.length > 10) {
                return {
                    status: true,
                    message: "*Mobile number should be 10 digits."
                };
            } else {
                // setIs_buttonDisabled(true);
                return {
                    status: false,
                    message: ""
                };
            }
        } else {
            return {
                status: true,
                message: "*                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    Please enter your mobile number."
            };
        }
    }

    const handleSignUpValidation = async () => {
        if (firstName == '' && lastName == '' && email == '') {
            return {
                status: true,
                first_name: '*Please enter first name',
                last_name: '*Please enter last name',
                email_id: '*Please enter email address'
            }
        } else if (firstName == '') {
            return {
                status: true,
                first_name: '*Please enter first name'
            }
        } else if (lastName == '') {
            return {
                status: true,
                last_name: '*Please enter last name'
            }
        } else if (email == '') {
            return {
                status: true,
                email_id: '*Please enter email address'
            }
        } else {
            return {
                status: false,
                first_name: '',
                last_name: '',
                email_id: ''
            }
        }
    }

    const addGoPointsToWallet = async (id) => {
        console.log("ID: ", id)
        const goPointsData = {
            promoCode: `${swiggyCode}`,
            user_id: id
        }
        try {
            console.log("goPointsData: ", goPointsData)
            const data = await post('promo_codes/apply_swiggy_code', goPointsData)
            console.log("SwiggyData: ", data)
            if (data.data.status === 200) {
                return {
                    status: 200
                }
            } else if (data.data.status === 422 && data.data.errors) {
                return {
                    status: 422,
                    data: data.data.errors
                }
            } else {
                return {
                    status: false,
                    data: "Something went wrong."
                }
            }
        } catch (error) {
            console.log("Error: ", error)
        }
    }

    const login = async (e) => {
        e.preventDefault()
        setIsOTPVerify(true)
        if (OTP !== "") {
            if (OTP.length === 4) {
                const dataForVerifyOTP = {
                    country_code: `+${countryCode}`,
                    mobile: `${enterMobileNo}`,
                    otp: `${OTP}`
                }
                try {
                    const verify_OTP_data = await post("ngp/verify-otp", dataForVerifyOTP)
                    console.log("Verify-OTP: ", verify_OTP_data)
                    if (verify_OTP_data.data.status === 200 && verify_OTP_data.data.isExistingUser === false) {
                        console.log("Header: ", verify_OTP_data.config.headers)
                        setActivateSignUpScreen(true)

                    } else if (verify_OTP_data.data.status === 200 && verify_OTP_data.data.data.user.ngp_name === "ngp_admin") {
                        // setShowSuccessToast(true)
                        setIsOTPVerify(false)
                        loginCookie(verify_OTP_data.data.data.token, verify_OTP_data.data.data.user.ngp_name)
                        history.push("/admin/dashboard")

                    } else if (verify_OTP_data.data.status === 200 && verify_OTP_data.data.data.user.isExistingUser === true && verify_OTP_data.data.data.user.ngp_name === "user") {
                        loginCookie(verify_OTP_data.data.data.token, verify_OTP_data.data.data.user.ngp_name)

                        let APPLY_SWIGGY_CODE = await addGoPointsToWallet(verify_OTP_data.data.data.user.id)
                        console.log("APPLY_SWIGGY_CODE: ", APPLY_SWIGGY_CODE)

                        if (APPLY_SWIGGY_CODE.status === 200) {
                            setIsOTPVerify(false)
                            history.push("/wallet", {
                                message: 'Balance Added To Your Wallet',
                                type: 'success'
                            })

                        } else if (APPLY_SWIGGY_CODE.status === 422) {
                            setIsOTPVerify(false)
                            history.push("/wallet", {
                                message: APPLY_SWIGGY_CODE.data,
                                type: 'danger'
                            })

                        }

                    } else if (verify_OTP_data.data.status === 400) {
                        setOTPError(verify_OTP_data.data.message)
                        setIsOTPVerify(false)
                        // setShowErrorToast(true)
                    }
                } catch (e) {
                    setIsOTPVerify(false)
                    setOTPError("There's network issue. Please try again.")
                    console.log("Error: ", e)
                }
            } else {
                setIsOTPVerify(false)
                setOTPError("*Please check your OTP")
            }
        } else {
            setIsOTPVerify(false)
            setOTPError("*Please enter OTP")
        }

    }

    const signUpForNewUser = async (e) => {
        e.preventDefault()
        try {
            let isSignUpValid = await handleSignUpValidation()
            if (!isSignUpValid.status) {
                setIsSignUpSuccess(true)
                const signUpForSwiggyUser = {
                    goPointUser: true,
                    user: {
                        first_name: `${firstName}`,
                        last_name: `${lastName}`,
                        mobile: `${enterMobileNo}`,
                        email: `${email}`,
                        country_code: `+${countryCode}`,
                    }
                }
                try {
                    const data = await post('ngp/sign-up', signUpForSwiggyUser)
                    if (data.data.status === 200 && data.data.message !== "Success") {
                        setIsSignUpSuccess(false)
                        setSignUp_Error({
                            status: true,
                            email_id: `*${data.data.message}`
                        })
                    } else if (data.data.status === 200 && data.data.message === "Success") {
                        loginCookie(data.data.data.token, data.data.data.user.ngp_name)
                        console.log("Data: ", data)
                        setShowSuccessToast(true)
                        setIsSignUpSuccess(false)

                        let apply_swiggy_code_after_Signup = await addGoPointsToWallet(data.data.data.user.id)
                        console.log("apply_swiggy_code_after_Signup: ", apply_swiggy_code_after_Signup)
                        if (apply_swiggy_code_after_Signup.status === 200) {
                            history.push("/wallet", {
                                message: 'Balance Added To Your Wallet',
                                type: 'success'
                            })

                        } else if (apply_swiggy_code_after_Signup.status === 422) {
                            history.push("/wallet", {
                                message: apply_swiggy_code_after_Signup.data,
                                type: 'danger'
                            })
                        }

                    } else if (data.data.status === 400) {
                        setIsSignUpSuccess(false)
                    }
                } catch (error) {
                    setIsSignUpSuccess(false)
                    console.log("Error: ", error)
                }
            } else {
                setIsSignUpSuccess(false)
                setSignUp_Error(isSignUpValid)
            }
        } catch (error) {
            console.log("Error: ", error)
            setSignUp_Error({
                status: true,
                something_went_wrong: "There's network issue or something went wrong. Please try again."
            })
        }
    }

    const mobileOTP = async (e) => {
        e.preventDefault()
        try {
            let isMobileNumbervalid = await handleMobileNumberValidation()

            if (!isMobileNumbervalid.status) {
                console.log("MobileNo: ", enterMobileNo)

                const dataForGetOTP = {
                    country_code: `+${countryCode}`,
                    mobile: `${enterMobileNo}`,
                    app_signature_id: "pb"
                };
                if (!isResendOTPClicked) {
                    setIsOTPSend(true)
                    try {
                        console.log("otpVerifyData: ", dataForGetOTP)
                        const { data } = await post("ngp/send-otp", dataForGetOTP);
                        if (data.status === 200) {
                            setActivateOTPScreen(true)
                            setActivateMobileField(false)
                            setIsOTPSend(false)
                        }
                    } catch (e) {
                        console.log("error: ", e)
                        setMobileError({
                            status: true,
                            message: "Something went wrong. Please try again.",
                        })
                        setIsOTPSend(false)
                    }
                } else {
                    try {
                        console.log("otpVerifyData: ", dataForGetOTP)
                        const { data } = await post("ngp/send-otp", dataForGetOTP);
                        if (data.status === 200) {
                            setToastForResendOTP(true)
                            setShowSuccessToast(true)
                            setIsResendOTPClicked(false)
                        }
                    } catch (e) {
                        console.log("error: ", e)
                        setOTPError("There's network issue. Please try again.")
                        setIsResendOTPClicked(false)
                        setShowSuccessToast(false)
                    }
                }
                // setActivateOTPScreen(true)
            } else {
                setIsOTPSend(false)
                setMobileError(isMobileNumbervalid)
            }

        } catch {
            setIsOTPSend(false);
            // toast.error("Failed to create parnter!");
        }
    }

    const validateSwiggyCode = async (e) => {
        e.preventDefault()
        if (swiggyCode !== "") {
            setIsSwiggyCodeVerified(true)
            const swiggyCodeData = {
                promCode: swiggyCode,
                goPointPartner: "swiggy"
            }
            console.log(swiggyCodeData)
            try {
                const { data } = await post('ngp/Validate_swiggy_code', swiggyCodeData)
                console.log("data: ", data)
                if (data.status === 404 && data.message === "This code has expired") {
                    setIsSwiggyCodeVerified(false)
                    setSwiggyCodeError("This code has expired.")
                } else if (data.status !== 200) {
                    setIsSwiggyCodeVerified(false)
                    setSwiggyCodeError("*Invalid Code")
                } else {
                    setShowSuccessToast(true)
                    setValidateSwiggyField(false)
                    setActivateMobileField(true)
                    setIsSwiggyCodeVerified(false)
                }
            } catch (e) {
                console.log("Error: ", e)
                // setShowErrorToast(true)
                setIsSwiggyCodeVerified(false)
                setSwiggyCodeError("There's network issue. Please check and try again.")
            }
        } else {
            setSwiggyCodeError('*Please enter promocode')
        }

    }
    return (
        <>
            <div className='page img-fluid background-banner'
            // style={{
            //     height: "100vh",
            //     backgroundSize:'100% 100%',
            //     width: "100%",
            //     backgroundImage: `url(${landing_background})`,
            //     backgroundRepeat:'no-repeat'
            // }}
            >
                {
                    showSuccessToast ?
                        <Row>
                            <Col md={9}></Col>
                            <Col md={3}>
                                <div
                                    className="position-fixed top-0 p-3 d-block justify-content-between"
                                    style={{ zIndex: "1005" }}
                                >
                                    <Toast
                                        delay={1000}
                                        // show={showSuccessToast}
                                        onClose={() => setShowSuccessToast(false)}
                                        autohide
                                    >
                                        <Toast.Body
                                            style={{ color: "#00000", height: "55px" }}
                                            className="text-16 bg-success text-white"
                                        >
                                            <div className="d-flex d-block justify-content-between">
                                                <i
                                                    className="fa fa-check-circle pt-1"
                                                    style={{ fontSize: 22 }}
                                                >
                                                </i>
                                                <p
                                                    style={{
                                                        fontSize: 18,
                                                        fontStyle: "normal",
                                                    }}
                                                    className="mx-2"
                                                >
                                                    {
                                                        !activateSignUpScreen && !activateOTPScreen ?
                                                            "Code verified Successfully"
                                                            :
                                                            activateOTPScreen && !activateSignUpScreen && toastForResendOTP ?
                                                                "OTP sent successfully"
                                                                :
                                                                activateOTPScreen && !activateSignUpScreen ?
                                                                    "OTP verified successfully"
                                                                    :
                                                                    activateSignUpScreen ?
                                                                        "Sign Up successfully"
                                                                        : null
                                                    }
                                                </p>
                                            </div>
                                        </Toast.Body>
                                    </Toast>
                                </div>
                            </Col>
                        </Row>
                        :
                        showErrorToast ?
                            <Row>
                                <Col md={10}></Col>
                                <Col md={2}>
                                    <div
                                        className="position-fixed top-0 p-3 d-block justify-content-between"
                                        style={{ zIndex: "1005" }}
                                    >
                                        <Toast
                                            delay={2000}
                                            show={true}
                                            onClose={() => setShowErrorToast(false)}
                                            autohide
                                        >
                                            <Toast.Body
                                                style={{ color: "#00000", height: "55px" }}
                                                className="text-16 bg-primary text-white"
                                            >
                                                <div className="d-flex d-block justify-content-between">
                                                    <i
                                                        className="fa fa-times-circle pt-1"
                                                        style={{ fontSize: 22 }}
                                                    >
                                                    </i>
                                                    <p
                                                        style={{
                                                            fontSize: 18,
                                                            fontStyle: "normal",
                                                        }}
                                                        className="mx-2"
                                                    >
                                                        {
                                                            activateOTPScreen ?
                                                                "Invalid OTP"
                                                                :
                                                                "Invalid Code"
                                                        }
                                                    </p>
                                                </div>
                                            </Toast.Body>
                                        </Toast>
                                    </div>
                                </Col>
                            </Row>
                            :
                            null
                }
                <Container>
                    <Row className='navbar-header-main'>
                        <div className="navbar-header swiggy-logo">
                            <a className="logo navbar-btn pull-left my-3" href={`${swiggyCode}`}>
                                <img src={logo_header} alt="HDFC" />
                            </a>
                        </div>
                    </Row>


                    {
                        // !validateSwiggyField && !activateMobileField && !activateOTPScreen && !activateSignUpScreen ?
                        // <div style={{padding:'10px'}} className="background-gradient landingPage-top">
                        //     <h2 className="font-weight-bold my-2 mx-3 text-white" style={{fontSize:'38px'}}>
                        //         Welcome To The Rewarding World
                        //     </h2>
                        //     <div style={{color:'white', marginTop:'5%'}} className="claim-banner">
                        //         <p className='banner-head' style={{fontWeight:'500'}}>
                        //             Congratulations!
                        //         </p>
                        //         <div className='banner-text'>
                        //             <span>
                        //                 You can use your INR 500 as a discount on
                        //             </span>
                        //             <span>
                        //                 over 200 brand gift vouchers.
                        //             </span>
                        //         </div>
                        //         <Button
                        //             type="button"
                        //             variant="primary"
                        //             className='text-uppercase border border-1 border-white mt-5 text-22 py-3 px-4 my-2'
                        //             style={{boxShadow:'none'}}
                        //             onClick={() => {
                        //                 setValidateSwiggyField(true)
                        //             }}
                        //             >
                        //             Claim Now
                        //         </Button>
                        //     </div>
                        // </div>
                        // : 
                        activateSignUpScreen ?
                            <div className="mt-5 sign-up-banner mobile-hide">
                                <h2 className="font-weight-bold my-2 text-white" style={{ fontSize: '38px' }}>
                                    Welcome To The Rewarding World
                                </h2>
                                <span className="my-3 text-white">
                                    Seems like you are not yet a member of gainon, just need your name & email to complete signup.
                                </span>
                            </div>
                            :
                            null
                    }
                    <Row className={`${!activateMobileField && !activateOTPScreen && !activateSignUpScreen ? "background-gradient landingPage-top" : ""}`}>
                        {
                            !activateMobileField && !activateOTPScreen && !activateSignUpScreen &&
                            <div style={{ padding: '10px' }} className="sign-up-banner">
                                <h2 className="font-weight-bold my-3 mx-3 text-white" style={{ fontSize: '38px' }}>
                                    Welcome To The Rewarding World
                                </h2>
                                <div style={{ color: 'white', marginTop: '10%' }} className="claim-banner">
                                    <p className='banner-head' style={{ fontWeight: '700' }}>
                                        Congratulations!
                                    </p>
                                    <div className='banner-text'>
                                        <span>
                                            You can use your INR 500 as a discount on<br />
                                            {" "}over 200 brand gift vouchers.
                                        </span>
                                    </div>
                                    {/* <Button
                                    type="button"
                                    variant="primary"
                                    className='text-uppercase border border-1 border-white mt-5 text-22 py-3 px-4 my-2'
                                    style={{boxShadow:'none'}}
                                    onClick={() => {
                                        setValidateSwiggyField(true)
                                    }}
                                    >
                                    Claim Now
                                </Button> */}
                                </div>
                            </div>
                        }
                        <Col md={6}>
                            {/* <Card className='brand-card container'> */}
                            <form onSubmit={!activateMobileField && !activateOTPScreen ? validateSwiggyCode : activateMobileField && !activateOTPScreen || isResendOTPClicked ? mobileOTP : activateOTPScreen && !activateSignUpScreen ? login : signUpForNewUser}>
                                <Row className='p-3'>
                                    {
                                        !activateOTPScreen ?
                                            <>
                                                {/* <Col md={1}></Col> */}
                                                {
                                                    !activateMobileField ?
                                                        <Col className='' md="8" sm="8">
                                                            <div className='form-group'>
                                                                <label className='text-16 my-3 text-white'>Please enter your unique promocode</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mb-2"
                                                                    name="promocode"
                                                                    value={swiggyCode}
                                                                    onFocus={() => setSwiggyCodeError('')}
                                                                    onChange={(e) => setSwiggyCode(e.target.value)}
                                                                    placeholder="Enter your promocode"
                                                                />
                                                                {
                                                                    swiggyCodeError && <span
                                                                        style={{
                                                                            color: "#FD1C03",
                                                                            fontSize: "15px",
                                                                        }}
                                                                    >{swiggyCodeError}</span>
                                                                }
                                                                <Button
                                                                    variant="primary"
                                                                    type="submit"
                                                                    disabled={isSwiggyCodeVerified}
                                                                    className="border border-1 border-white col-lg-6 submit-btn text-20"
                                                                    block
                                                                >
                                                                    {isSwiggyCodeVerified ? (
                                                                        <Spinner animation="border" size="sm" />
                                                                    ) : "CLAIM NOW"}
                                                                </Button>
                                                            </div>

                                                        </Col>
                                                        :
                                                        activateMobileField ?
                                                            <Col className='banner-content background-gradient' md="8" sm="6">
                                                                <div className="form-group">
                                                                    <label className='text-16 my-3 text-white'>Enter Mobile Number</label>
                                                                    <PhoneInput
                                                                        // disabled={is_buttonDisabled}
                                                                        onChange={handleInputChange}
                                                                        onEnterKeyPress={mobileOTP}
                                                                        inputStyle={{
                                                                            fontWeight: 'normal'
                                                                        }}
                                                                        country={"in"}
                                                                        className="mb-2"
                                                                        // flagsImagePath="/flags.723494a4.png"
                                                                        onFocus={() => setMobileError({})}
                                                                    />
                                                                    {
                                                                        mobileError.status && <span
                                                                            style={{
                                                                                color: "#FD1C03",
                                                                                fontSize: "15px",
                                                                            }}
                                                                        >{mobileError.message}</span>
                                                                    }

                                                                    <Button
                                                                        variant="primary"
                                                                        type="submit"
                                                                        className="border border-1 border-white col-lg-6 get-otp-btn"
                                                                        block
                                                                        disabled={isOTPSend}
                                                                    // onClick={mobileOTP}
                                                                    >
                                                                        {isOTPSend ? (
                                                                            <Spinner animation="border" size="sm" />
                                                                        ) : "SEND OTP"}
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                            :
                                                            null
                                                }
                                                {/* <Col md={1}></Col> */}
                                            </>
                                            :
                                            !activateSignUpScreen ?
                                                <Col className='banner-content background-gradient' md="8" sm="6">
                                                    <div className='form-group justify-content-center'>
                                                        <p className='text-white py-2 my-2 text-22' style={{ fontWeight: 600 }}>Enter OTP</p>
                                                        <p className='pt-2 text-white text-14'>
                                                            {`A 4 digit OTP has been sent to +${countryCode} ${enterMobileNo}`}
                                                        </p>
                                                        <p className='pb-2 text-white text-14'>

                                                        </p>
                                                        <OtpInput

                                                            className="hello"
                                                            onChange={(otp) => {
                                                                setOTP(otp)
                                                                setOTPError('')
                                                            }}
                                                            focusStyle={{
                                                                borderBottom: "3px solid yellow",

                                                            }}
                                                            numInputs={4}
                                                            inputStyle={{
                                                                // width:'60px',
                                                                // height:'50px',
                                                                // margin:'5px 10px 10px 10px',
                                                                width: "60px",
                                                                textAlign: "center",
                                                                height: "50px",
                                                                margin: "5px 10px 10px",
                                                                background: "transparent",
                                                                outline: "yellow",
                                                                borderBottom: "2.5px solid white",
                                                                borderLeft: "none",
                                                                borderRight: "none",
                                                                borderTop: "white",
                                                                color: "white",
                                                                fontSize: "18px",
                                                                fontWeight: "700",

                                                            }}

                                                            value={OTP}
                                                            isInputNum={false}
                                                            // hasErrored={OTPError}
                                                            shouldAutoFocus={true}

                                                        // containerStyle="box-otp"
                                                        />
                                                        {
                                                            OTPError && <span
                                                                style={{
                                                                    color: "#FD1C03",
                                                                    fontSize: "15px",
                                                                }}
                                                            >{OTPError}</span>
                                                        }
                                                        <Button
                                                            variant="primary"
                                                            type="submit"
                                                            className="my-2 text-center justify-content-center col-lg-6"
                                                            block
                                                            disabled={isOTPVerified}
                                                        // onClick={(e) => mobileOTP(e)}
                                                        >
                                                            {isOTPVerified ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : "Verify OTP"}
                                                        </Button>
                                                        <button
                                                            type='submit'
                                                            className="btn btn-link text-white text-12 col-lg-6"
                                                            onClick={() => {
                                                                setIsResendOTPClicked(true)
                                                                setToastForResendOTP(false)
                                                            }}
                                                        >
                                                            Resend OTP
                                                        </button>
                                                    </div>
                                                </Col>
                                                :
                                                <Col md="8" className='background-gradient mobile-view' style={{ flexDirection: 'column' }}>
                                                    <div className="form-group my-3 text-left mobile-view" style={{ flexDirection: 'column' }}>
                                                        <label className='text-white'>
                                                            First Name <span>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            onFocus={() => setSignUp_Error({})}
                                                            name="fname"
                                                            placeholder="Enter First Name"
                                                            value={firstName}
                                                            onChange={(e) => setFirstName(e.target.value)}
                                                            className="form-control"
                                                        />
                                                        {
                                                            signUp_Error.status && <span
                                                                style={{
                                                                    color: "#FD1C03",
                                                                    fontSize: "15px",
                                                                }}
                                                            >{signUp_Error.first_name}</span>
                                                        }
                                                    </div>
                                                    <div className="form-group my-3 text-left">
                                                        <label className='text-white'>
                                                            Last Name <span>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="lname"
                                                            onFocus={() => setSignUp_Error({})}
                                                            placeholder="Enter Last Name"
                                                            value={lastName}
                                                            onChange={(e) => setLastName(e.target.value)}
                                                            className="form-control"
                                                        />
                                                        {
                                                            signUp_Error.status && <span
                                                                style={{
                                                                    color: "#FD1C03",
                                                                    fontSize: "15px",
                                                                }}
                                                            >{signUp_Error.last_name}</span>
                                                        }
                                                    </div>
                                                    <div className="form-group my-3 text-left">
                                                        <label className='text-white'>
                                                            Email Address <span>*</span>
                                                        </label>
                                                        <input
                                                            type="email"
                                                            onFocus={() => setSignUp_Error({})}
                                                            name="email"
                                                            placeholder="Enter Email Address"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            className="form-control"
                                                        />
                                                        {
                                                            signUp_Error.status && <span
                                                                style={{
                                                                    color: "#FD1C03",
                                                                    fontSize: "15px",
                                                                }}
                                                            >{signUp_Error.email_id}</span>
                                                        }
                                                        {
                                                            signUp_Error.status && signUp_Error.something_went_wrong && <span
                                                                style={{
                                                                    color: "#FD1C03",
                                                                    fontSize: "15px",
                                                                }}
                                                            >{signUp_Error.something_went_wrong}</span>
                                                        }
                                                        <Button
                                                            variant="primary"
                                                            type="submit"
                                                            block
                                                            className='my-4 text-center justify-content-center col-lg-6'
                                                            disabled={isSignUpSuccess}
                                                        >

                                                            {console.log(isSignUpSuccess)}
                                                            {isSignUpSuccess ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : "Sign Up"}
                                                        </Button>
                                                    </div>
                                                </Col>

                                    }
                                </Row>
                            </form>
                            {/* </Card> */}
                        </Col>
                        {/* <Col md={3}></Col> */}
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Swiggy_Integration


